var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-2"},[_c('CRow',[_c('CCol',{attrs:{"sm":_vm.getCol}},[_c('Grid',{attrs:{"isFind":true,"fields":_vm.fields,"items":_vm.items},on:{"grid-dbclick":function($event){_vm.gridDbclick = $event}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }